export type ResolvedLink =
  | { kind: 'guide'; id: string }
  | { kind: 'app'; to: string }
  | { kind: 'anchor'; href: string }
  | { kind: 'external'; href: string };

export function resolveLink(href: string): ResolvedLink {
  const value = (href ?? '').trim();
  if (!value) return { kind: 'anchor', href: '#' };
  if (value.startsWith('guide:'))
    return { kind: 'guide', id: value.slice('guide:'.length) };
  if (value.startsWith('#')) return { kind: 'anchor', href: value };
  if (value.startsWith('/')) return { kind: 'app', to: value };
  return { kind: 'external', href: value };
}
